package com.essntl.features.price.domain.model.staticprice

data class PriceMarkupModel(
    val id: String,
    val name: String,
    val value: Double,
    val createdAt: String,
    val description: String?,
    val isDefault: Boolean?,
    val updatedAt: String?,
    val createdBy: String?,
    val updatedBy: String?,
)
